var render, staticRenderFns
import script from "./base-import-dialog.vue?vue&type=script&lang=js"
export * from "./base-import-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02266035')) {
      api.createRecord('02266035', component.options)
    } else {
      api.reload('02266035', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/pages/import/dialogs/base-import-dialog.vue"
export default component.exports